import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { WaterVaporSvgComponent } from './water-vapor-legend/water-vapor-legend-svg';

export const WATER_VAPOR_LEGEND: TwcLegendParams = {
  title: 'WATER VAPOR',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: WaterVaporSvgComponent },
  legendComponent: TwcLegendComponent
};
